"use client";

import { GenericListPage, type GenericListConfig } from "@admin/_components/generic-list-page";

const config: GenericListConfig = {
  title: "Webinar Management",
  subtitle: "Manage webinars",
  listEndpoint: "webinar/webinar-list",
  countEndpoint: "webinar/webinar-list-count",
  deleteEndpoint: "webinar/webinar-delete",
  statusEndpoint: "webinar/webinar-status-change",
  addPath: "/admin/webinars/add",
  editPath: "/admin/webinars/edit",
  addButtonLabel: "+ Add Webinar",
  columns: [
    { key: "title", label: "Title", sortable: true },
    { key: "priority", label: "Priority", sortable: true },
    { key: "status", label: "Status", type: "status" },
    // W-05: Angular uses createdon_datetime not created_at
    { key: "createdon_datetime", label: "Created At", type: "date", sortable: true },
  ],
  searchFields: [
    { label: "Title", field: "title" },
  ],
  filterFields: [
    {
      label: "Status",
      field: "status",
      values: [
        { val: "1", name: "Active" },
        { val: "0", name: "Inactive" },
      ],
    },
  ],
  // W-07: Date range filter on createdon_datetime
  dateRangeFields: [
    { label: "Created Date", field: "createdon_datetime" },
  ],
  // W-01: Row preview using list row data
  previewFromRow: true,
  previewFields: [
    { key: "title", label: "Title" },
    { key: "description", label: "Description", type: "html" },
    { key: "priority", label: "Priority" },
    { key: "frequency", label: "Frequency" },
    { key: "createdon_datetime", label: "Created On", type: "date" },
    { key: "status", label: "Status", type: "badge" },
  ],
};

export default function WebinarsPage() {
  return <GenericListPage config={config} />;
}
